module.exports = __webpack_public_path__ + "img/ethereum.0fc37bfa.svg";